import { useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import Dealers from "../../components/Dealers/Dealers";
import LeadForm from "../../components/LeadForm/LeadForm";
import MakeSelection from "../../components/MakeSelection/MakeSelection";
import ModelSelection from "../../components/ModelSelection/ModelSelection";
import Zipcode from "../../components/Zipcode/Zipcode";
import ZipSelection from "../../components/ZipSelection/ZipSelection";
import { fetchCarDealers, fetchCarModelsDump, fetchTopNModels, submitLead } from "../../services/api";
import { formatPrice, getQueryParam, isMobile, scroll, scrollToTop, storeInLocal, useForceUpdate } from "../../services/shared";
import CarDetails from "../Progressive/CarDetails/CarDetails";


import './ProgressiveForm.scss';

let masterCarList = [];
let facts = {};

function setFacts(v){
    facts = v;
}


const ProgressiveForm = (props)=>{
    const url = new URL(window.location);
    const params = url.searchParams;

    const [oem,setOem] = useState(params.get('oem'));

    const [step,setStep] = useState(params.get('step'));

    const [make,setMake] = useState(params.get('make'));
    const [model,setModel] = useState(params.get('model'));
    const [year, setYear] = useState("2021");
    const [car,setCar] = useState(null);
    const [zip,setZip] = useState(params.get('zip'));
    const [stateCode,setStateCode] = useState(params.get('streetCode'));
    const [city,setCity] = useState(params.get('city'));


    const [modelOptions, setModelOptions] = useState([]);
    const [yearOptions, setYearOptions] = useState([]);
    const [trimOptions, setTrimOptions] = useState([]);
    const [topNModels, setTopNModels] = useState([]);

    const [suggestedZip,setSuggestedZip] = useState(null);
    const [noDealersFound, setNoDealersFound] = useState(false);
    const [editZipCode, setEditZipCode] = useState(false);

    const [dealerList, setDealerList] = useState([])

    const [oemSubmissionId, setOemSubmissionId] = useState(null);
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);

    useEffect(()=>{
        if(step === "car-details"){
            params.set('landing-page','car-details')
        }
        getDealers();
    },[])
    
    useEffect(()=>{
        if(make){
            fetchCarModelsDump(make).then(cars=>{
                masterCarList = cars;
                getModels();
                if(model){
                    getYears();
                    getTrims();
                }
            })
            params.set('make',make);
            window.history.pushState({},'',url);
        }
        
    },[make])

    useEffect(()=>{
        if(model){
            params.set('model',model);
            window.history.pushState({},'',url);
            if(masterCarList.length){
                getYears();
                getTrims();
            }
        }
    },[model])

    useEffect(()=>{
        if(zip){
            params.set('zip',zip);
            window.history.pushState({},'',url);
        }
    },[zip])

    useEffect(()=>{
        if(make && modelOptions.length > 10){
            fetchTopNModels(make).then(models=>{
                setTopNModels(models);
            })
        }
    },[modelOptions])

    useEffect(()=>{
        if(step){
            params.set('step',step);
            window.history.pushState({},'',url);
            hasNecessaryParams();
        }
        if(step === "dealers-loading"){
            scrollToTop();
            document.body.style.overflow = "hidden";
        }else{
            document.body.style.overflow = "auto";
        }
    },[step])

    const hasNecessaryParams = ()=>{
        if(step === 'make-selection' || !step){
            void(0)
        }else if(step === 'model-selection'){
            if(!make){
                setStep('make-selection')
            }
        }else if(step === 'zip-selection'){
            if(!make){
                setStep('make-selection')
            }else if(!model){
                setStep('model-selection')
            }
        }else if(step === 'car-details'){
            if(!make){
                setStep('make-selection')
            }else if(!model){
                setStep('model-selection')
            }
        }else if(step === 'dealers-selection' || step === 'dealers-loading'){
            if(!make){
                setStep('make-selection')
            }else if(!model){
                setStep('model-selection')
            }else if(!zip){
                setStep('zip-selection')
            }else if(!dealerList.length){
                getDealers(zip)
            }
        }else if(step === 'lead-form'){
            if(!make){
                setStep('make-selection')
            }else if(!model){
                setStep('model-selection')
            }else if(!zip){
                setStep('zip-selection')
            }else if(!dealerList.length){
                getDealers(zip);
                setStep('dealers-loading')
            }
        }
    }


    const getModels = ()=>{
        const temp = [];
        masterCarList.sort((a,b)=>a.model>b.model?1:-1).forEach((car) => {
            const alreadyExistsIndex = temp.findIndex(_=>_.name === car.model);
            if(alreadyExistsIndex === -1){
                temp.push({
                    value: car.model,
                    name: car.model,
                    autoId: car.id,
                    price: car.price,
                    recommendedPrice: car.recommendedPrice,
                    image: car.imageUrls[0]
                })
                setOem(car.dealershipOem)
            }
        });
        setModelOptions(temp);
    }
    function getYears(){
        const temp = [];
        masterCarList.filter(_=>_.model === model).forEach((car) => {
            const alreadyExistsIndex = temp.findIndex(_=>_.name === car.year);
            if(alreadyExistsIndex === -1){
                temp.push({
                    value: car.year,
                    name: car.year
                })
            }
        });
        setYearOptions(temp);
    }

    function getTrims(){
        const trims = masterCarList.filter(_=>_.model === model && _.year === year).map(car=>{
            return {
                value: car.title+'*',
                name: car.title+'*',
                image: car.imageUrls ? car.imageUrls[0] : null,
                oem: car.dealershipOem,
                ...car
            }
        });
        setTrimOptions(trims);
        if(!params.get('trim')) {
            if(trims.length){
                let defaultTrim = trims[0];
                for(let trim of trims)
                    if(trim.image) {
                        defaultTrim = trim
                        break;
                    }
                setCar(defaultTrim);
                setOem(defaultTrim.oem);
            }
        } else {
            const selected = trims.find(_ => _.name === params.get('trim'));
            if(selected){
                setCar(selected);
                setOem(selected.oem);
            }else{
                if(trims.length){
                    let defaultTrim = trims[0];
                    for(let trim of trims)
                        if(trim.image) {
                            defaultTrim = trim
                            break;
                        }
                    setCar(defaultTrim);
                    setOem(defaultTrim.oem);    
                }
            }
        }
    }

    const getDealers = (zip)=>{
        const size = isMobile()?5:6;

        fetchCarDealers(make,model,year,zip,oem,size).then(data =>{

            window.dataLayer.push({
                'event': 'Recieved new dealers',
                'event_make': make,
                'event_model': model,
                'event_year': year,
                'event_trim': car?.name,
                'event_no_dealers_found': data?.dealers?.length === 0 ? 'true':'false',
                'event_zipcode': zip,
                'event_no_of_dealers': data.dealers.length
            })

            setSuggestedZip(data.zipcode);
            setDealerList(data.dealers.slice(0,3));

            if(data?.city && data?.statecode){
                setStateCode(data?.statecode)
                setCity(data?.city)
            }
            if(data?.oemSubmissionId){
                setOemSubmissionId(data?.oemSubmissionId);
            }

            if(data?.dealers?.length && zip){
                setTimeout(()=>{
                    setStep('dealers-selection');
                },2000)
            }else{
                if(zip){
                    setNoDealersFound(true);
                    if(make && model){
                        setStep('zip-selection');
                    }
                }else if(make && model ){
                    if(params.get('landing-page') === "car-details"){
                        setStep('car-details')
                    }else{
                        setStep('zip-selection');
                    }
                }
                    
            }

        },()=>{
            if(zip){
                setNoDealersFound(true);
                if(make && model){
                    setStep('zip-selection');
                }
            }else if(make && model ){
                if(params.get('landing-page') === "car-details"){
                    setStep('car-details')
                }else{
                    setStep('zip-selection');
                }
                
            }
        })
    }

    const closeAllPopup = ()=>{
        setEditZipCode(false);
    }

    function getSelectedDealers(){
        return dealerList.filter(_=>_.checked);
    }

    function handleMakeModelChange(newMake,newModel,newYear,newCar){
        window.dataLayer.push({
            'event': 'Submit model year',
            'event_make': newMake,
            'event_model': newModel,
            'event_year': newYear,
            'event_trim': newCar?.name
        })
        setMake(newMake);
        setModel(newModel);
        setCar(newCar);
        setYear(newYear)
    }


    const onSubmit = data => {
        if(getSelectedDealers().length){
            setIsFormSubmitting(true);
            window.dataLayer.push({
                'event': 'Submit form',
                'eventCallback' : (id)=>{
                    if(!id || id === "GTM-WQPK2Q5"){
                        submitLead({
                            firstName: data.firstName,
                            lastName: data.lastName,
                            email: data.email,
                            phone: data.phone,
                            zipcode: zip,
                            statecode: stateCode,
                            city: city,
                            street: data.street,
                            autoId: car.id,
                            oemSubmissionId: oemSubmissionId,
                            dealershipOems: oem, 
                            dealers: getSelectedDealers(),
                            make: make
                        }).then((res)=>{
                            const personal = {
                                firstName: data.firstName,
                                lastName: data.lastName,
                                email: data.email,
                                phone: data.phone,
                                zipcode: zip,
                                statecode: stateCode,
                                city: city,
                                street: data.street,
                            }
                            storeInLocal('personal', personal);
                            storeInLocal('oemSubmissionId', oemSubmissionId);
                            storeInLocal('selectedDealers', getSelectedDealers());
                            storeInLocal('suggestedCars',res.data.similarAutos)
                            window.location.href = `/thankyou?${params.toString()}&id=${res.data.submissionId}&showRecommendedPrice=true&baseUrl=/progressive`;
                        })
                    }
                },
                'eventTimeout' : 2000,
                'event_make': make,
                'event_model': model,
                'event_year': year,
                'event_zipcode': zip,
                'event_no_of_dealers': getSelectedDealers().length
            })
        }else{
            setStep('dealers-selection');
        }
        
    }

    const zipCodeSubmitHandler = (data) => {
        window.dataLayer.push({
            'event': 'Changed ZIP code',
            'event_make': make,
            'event_model': model,
            'event_year': year,
            'event_zipcode': data.zipcode
        })
        setStep('dealers-loading');
        getDealers(data.zipcode);
        setZip(data.zipcode);
        setEditZipCode(false);
    }

    const dealerCheckedHandler = (dealer, i) => {
        setDealerList(JSON.parse(JSON.stringify(dealerList)));
        window.dataLayer.push({
            'event': 'Changed dealer',
            'event_make': make,
            'event_model': model,
            'event_year': year,
            'event_is_dealer_selected': dealer.checked,
            'event_dealer_position': i
        })
    }

    const renderStep = ()=>{

        switch(step){
            case null:
            case "":
                case "make-selection": 
                return <MakeSelection
                    makeSelected={(make)=>{
                        setMake(make);
                        setStep('model-selection')
                    }}
                ></MakeSelection>

            case "model-selection":
                return <ModelSelection
                    make={make}
                    modelOptions={modelOptions}
                    topNModels={topNModels}
                    modelSelected={(model)=>{
                        setModel(model);
                        if(params.get('landing-page') === "car-details"){
                            setStep('car-details')
                        }else{
                            setStep('zip-selection');
                        }
                    }}
                ></ModelSelection>

            case "car-details":
                return <div className="step-body-wrapper">
                    <div className="step-header">Buying a new {make} {model}</div>
                    <div className="step-sub-header">Let us find you the best deals in your neighborhood.</div>
                    <CarDetails
                        make={make}
                        model={model}
                        year={year}
                        car={car}
                        masterCarList={masterCarList}
                        modelOptions={modelOptions}
                        yearOptions={yearOptions}
                        trimOptions={trimOptions}
                        handleMakeModelChange={handleMakeModelChange}
                        ctaClicked={()=>{
                            window.dataLayer.push({
                                'event': 'Car details continue',
                                'event_make': make,
                                'event_model': model,
                                'event_year': year,
                                'event_zipcode': zip
                            })
                            if(zip){
                                setStep('dealers-loading');
                            }else{
                                setStep('zip-selection');
                            }
                                
                        }}
                    ></CarDetails>
                </div>
            case "zip-selection":
                return <ZipSelection
                    make={make}
                    model={model}
                    year={year}
                    noDealersFound={noDealersFound}
                    zipSelected={(zip)=>{
                        zipCodeSubmitHandler({zipcode: zip});
                    }}
                    suggestedZip={suggestedZip}
                ></ZipSelection>
            case "dealers-loading":
                return (
                    <div className="dealers-loading-wrapper">
                        <Loader type="ThreeDots" color="#526FFF" height={40} width={50}/>
                        Fetching local dealers that will give the best deals
                        {car && <div className="estimate-savings">Savings estimate of <span className="amount">${formatPrice((parseFloat(car.price) - parseFloat(car.recommendedPrice)).toString())}</span></div>}
                    </div>
                )
            case "dealers-selection":
                return (
                    <div className="step-body-wrapper">
                        <Zipcode
                            autoSearch={true}
                            zipCodePopupOpenCb={() => {
                                closeAllPopup();
                                setEditZipCode(true);
                            }}
                            dealersLoading={false} 
                            dealerList={dealerList}
                            editZipCode={editZipCode}
                            zipCode={zip}
                            stateCode={stateCode}
                            zipCodeSubmitHandler={zipCodeSubmitHandler}
                        />
                        <Dealers
                            oem={oem}
                            make={make}
                            model={model}
                            btnTxt="Continue"
                            secondaryTxt="Last step ahead"
                            dealerList={dealerList}
                            zipCode={zip}
                            hideCTA={false}
                            dealerCheckedHandler={(dealer,i)=>{
                                closeAllPopup();
                                dealerCheckedHandler(dealer,i)
                            }}
                            dealerContinueActionHandler={()=>{
                                window.dataLayer.push({
                                    'event': 'Continue',
                                    'event_make': make,
                                    'event_model': model,
                                    'event_year': year,
                                    'event_trim': car?.name
                                })
                                setStep('lead-form');
                            }}
                            bttnLoader={false} 
                        />
                    </div>
                )
            case "lead-form":
                return (
                    <div className="step-body-wrapper">
                        <div className="step-header">Last Step: About you</div>
                        <div className="step-sub-sub-header">Your information is protected and will only be shared with the dealers that you’ve selected.</div>
                        <LeadForm
                            make={make}
                            model={model}
                            year={year}
                            stateCode={stateCode}
                            zip={zip}
                            city={city}
                            forceSecondPhase = {true}
                            isFormSubmitting = {isFormSubmitting}
                            onSubmit = {onSubmit}
                            templateId={props.templateId}
                            ctaText="See Price Now"
                            setFacts={setFacts}
                        ></LeadForm>
                    </div>
                )

        }
    }
    return (<>
        <div className="progressive-form-body">
            <ul className="breadcrumb">
                { make && 
                    <li>{make}</li>
                }
                { model && 
                    <li>{model}</li>
                }
            </ul>
            {
                renderStep()
            }   
        </div>
        
        
    </>)
}
export default ProgressiveForm;